import { createSvgIcon } from "@mui/material";

export const NewIndicatorIcon = createSvgIcon(
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="3.99999" cy="4" rx="3.91375" ry="4" fill="#EF5350" />
  </svg>,
  "NewIndicatorIcon",
);
